<template>
    <div class="modal" :class="{ 'is-active': show }">
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Ciudadano reasignado</p>
            </header>
            <section class="modal-card-body">
                El ciudadano ha sido reasignado a otro operador, se le va a
                redirigir de nuevo a la cola para que pueda atender a otro
                ciudadano.
            </section>
            <footer class="modal-card-foot">
                <button class="button" @click="goQueue">Aceptar</button>
            </footer>
        </div>
    </div>
</template>

<script>
export default {
    name: "not-valid-room-modal",
    props: {
        show: {
            tpye: Boolean,
            default: false,
        },
    },
    methods: {
        goQueue() {
            this.$router.push({
                name: "online-operator",
            });
        },
    },
};
</script>